<template>
  <div class="footer">
    <div class="content">
      <div class="link">
        <span>友情链接：</span>
        <a class="content-header" :href="item" v-for="(item,key, index) in links" :key="key">
          <span v-if="index!=0">&nbsp;|</span>
          {{key}}
        </a>
      </div>
      <img :src="qrcode" alt class="content-bady-wechat" />
      <div class="content-bady-describe">羁绊网官方微信</div>
      <div class="content-fotter">
        <img :src="logo" class="content-fotter-img" />
        <div class="conten-fotter-describe">
          <div class="link">
            <a
              class="content-header"
              :href="item"
              v-for="(item,key, index) in otherLink"
              :key="key"
            >
              <span v-if="index!=0">&nbsp;|</span>
              {{key}}
            </a>
          </div>
          <div>{{copyright}}</div>
          <div>{{icp}}</div>
          <div>
            <img src="../img/jh.png" style="height:18px;widht:16px;margin-right:6px" />
            <span>{{poiceICP}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      list: "",
      logo: "",
      links: "",
      qrcode: "",
      otherLink: "",
      copyright: "",
      icp: "",
      poiceICP: ""
    };
  },
  methods: {},
  beforeCreate() {
    this.$http.get("conf").then(res => {
      this.list = res.body.data.conf;
      this.links = JSON.parse(res.body.data.conf[1].value);
      this.qrcode = res.body.data.conf[2].value;
      this.logo = res.body.data.conf[3].value;
      this.otherLink = JSON.parse(res.body.data.conf[4].value);
      this.copyright = res.body.data.conf[5].value;
      this.icp = res.body.data.conf[6].value;
      this.poiceICP = res.body.data.conf[7].value;
    });
  } //生命周期 - 创建之前
};
</script>

<style scoped="scoped">
.footer {
  width: 100%;
  background-color: #333333;
}
.content {
  width: 1200px;
  height: 348px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px 0;
  margin: 0 auto;
  box-sizing: border-box;
}
.content-header {
  color: #cccccc;
  font-size: 12px;
}
.content-bady-wechat {
  height: 90px;
  width: 90px;
  margin: 30px 0 10px;
  border: 10px solid #28a3b1;
  border-radius: 6px;
}
.content-bady-describe {
  color: #cccccc;
  font-size: 12px;
}
.content-fotter {
  display: flex;
  flex-direction: row;
  margin-top: 30px;
}
.content-fotter-img {
  height: 70px;
  width: 190px;
}
.conten-fotter-describe {
  color: #cccccc;
  font-size: 12px;
  margin-left: 60px;
}
.conten-fotter-describe > div {
  line-height: 22px;
  height: 22px;
  display: flex;
  align-items: center;
}
.link > a:first-child span {
  display: none;
}
.link {
  display: flex;
  flex-direction: row;
  align-items: center;
  color: #cccccc;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/Fotter.vue